import { Avatar, Grid, Typography } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { AppImageDimension, AppImages } from "app/appImages";
import { MprcLink } from "components";
import { MprcMarkdown } from "components/MprcMarkdown";
import { GlobalSearchAttachDto, KnowledgeSearchDto, PublicationAttachType } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import * as React from "react";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { UserProfileDialog } from "views/foundation/user/dialogs/UserProfileDialog";
import { buildHeadLine } from "views/general/GlobalSearch/components/SearchRenderPublication";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: KnowledgeSearchDto;
    index: number;
    onBeforeLinkClick?: () => void;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////////////////

export const SearchRenderVideo: React.FC<Props> = (props) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [dialog, setDialog] = useState<any>();
    const { data, index, onBeforeLinkClick } = props;

    const navUrl = KnowledgePaths.PublicationViewerResolver(data.publicationId, data.publicationType, data.linkedPublicationId);

    const headline = buildHeadLine((data.attachs.length >= 1 ? data.attachs[0].headline : null) ?? data.headline ?? data.summary);
    const mediaDuration = data.attachs.length == 1 ? data.attachs[0].duration : null;

    const navToAttach = (attach: GlobalSearchAttachDto) => {
        if (attach.attachType == PublicationAttachType.Video || attach.attachType == PublicationAttachType.YouTube || attach.attachType == PublicationAttachType.Vimeo) {
            navigate(navUrl, { state: { attachId: attach.attachId, searchText: searchParams.get("q") } });
        }
        else {
            navigate(navUrl);
        }
    };

    const renderSubtitle = (
        <Typography variant="subtitle1" fontWeight="bold">
            <MprcLink
                color="inherit"
                onClick={() => setDialog(
                    <UserProfileDialog
                        userId={data.authorId}
                        onClose={() => setDialog(null)}
                        onBeforeLinkClick={onBeforeLinkClick}
                    />
                )}
            >
                {data.authorName}
            </MprcLink>
            ,&nbsp;
            {Formaters.relativeTime(data.lastUpdate)}
            {
                mediaDuration && <>&nbsp;&bull;&nbsp;{Formaters.secondsToFullTime(mediaDuration)}</>
            }
        </Typography>
    );

    const renderHeadline = headline && (
        <Typography variant="caption" component="div" color="muted.light">
            <MprcMarkdown>{headline}</MprcMarkdown>
        </Typography>
    );

    return (
        <React.Fragment key={"searchVideo-" + index}>
            {dialog}
            <Grid container spacing={2}>
                {
                    <Grid>
                        <Avatar
                            variant="rounded"
                            src={data.thumbnailUrl ?? AppImages.VideoMp4Thumbnail}
                            sx={{ width: AppImageDimension.ThumbnailWide.width / 2, height: AppImageDimension.ThumbnailWide.height / 2 }}
                        />
                    </Grid>
                }
                <Grid size="grow">
                    <Typography
                        variant="body1"
                        color="primary.main"
                        className={AppGlobalClassKeys.clickable}
                        onClick={
                            () => {
                                onBeforeLinkClick && onBeforeLinkClick();
                                if (data.attachs.length == 0) navigate(navUrl);
                                else navToAttach(data.attachs[0]);
                            }
                        }
                    >
                        {data.title}
                    </Typography>
                    {renderSubtitle}
                    {renderHeadline}
                </Grid>
            </Grid>
        </React.Fragment>
    );
};
